<template>
  <div class="transaction-main">
    <div class="main">
      <div class="main-top marleft40" style="margin-top: 40px">
        <p class="p order-number martop5 fl">订单编号</p>
        <input
          type="text"
          class="order-number-input fl select-text"
          placeholder="请输入订单编号"
        />
        <p></p>
        <p class="mold fl martop5 p">类型</p>
        <select class="mold-select fl select-text">
          <option value="">数字货币</option>
          <option value="">现金</option>
        </select>
        <p class="pay-type fl martop5 p">支付方式</p>
        <select class="pay-type-select fl select-text">
          <option value="">全部</option>
          <option value="">支付宝</option>
          <option value="">微信</option>
        </select>
        <button class="resetting fr">重置</button>
        <button class="search fr">查询</button>
        <div class="clear"></div>
        <p class="time-scope fl p">时间范围</p>
        <input
          type="text"
          class="time-input fl select-text"
          placeholder="开始日期"
        />
        <div class="crossing fl"></div>
        <input
          type="text"
          class="fl select-text time-input"
          placeholder="结束日期"
        />
        <div class="clear"></div>
      </div>
      <div class="main-body">
        <div class="main-body-one" >
          <div class="body-one-left fl" >
            <div class="opa1" v-for="(item, index) in bodydata_one" :key="index" >
              <div class="opa-img fl">{{item.img}}</div>
              <p class="opa-type fl">{{item.allincome}}</p>
              <div class="clear"></div>
              <p class="opa-count fl">{{item.money}}</p>
            </div>
          </div>
          <div class="body-one-line fl"></div>
          <div class="body-one-right fr">
            <div class="opa1" v-for="(item, index) in bodydata_two" :key="index">
              <div class="opa-img fl">{{item.img}}</div>
              <p class="opa-type fl">{{item.allincome}}</p>
              <div class="clear"></div>
              <p class="opa-count fl">{{item.money}}</p>
            </div>
          </div>
        </div>
        <div class="main-body-two">
          <el-table
            :data="
              tableData.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )
            "
            :default-sort="{ prop: 'date', order: 'descending' }"
            stripe
            style="width: 97%"
            class="body-table"
            :row-style="{ height: '46px' }"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="date" label="编号"></el-table-column>
            <el-table-column prop="name" label="类型"></el-table-column>
            <el-table-column prop="address" label="金额"> </el-table-column>
            <el-table-column prop="address" label="来源"> </el-table-column>
            <el-table-column prop="address" label="时间"> </el-table-column>
            <el-table-column prop="address" label="操作"
              ><a href="" class="refund">退款详情</a></el-table-column
            >
          </el-table>
        </div>
      </div>
      <div class="main-bottom">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="1000"
          class="fenye"
          @current-change="current_change"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "transactionManage",
  data() {
    return {
      bodydata_one:[
        {
          img: '**',
          allincome: '总金额（元）',
          money: '12000'
        },
        {
          img: '**',
          allincome: '总支出（元）',
          money: '1254'
        },
        {
          img: '**',
          allincome: '订单总数（笔）',
          money: '7859'
        },
      ],
       bodydata_two:[
        {
          img: '**',
          allincome: '微信',
          money: '1220'
        },
        {
          img: '**',
          allincome: '支付宝',
          money: '1234'
        },
        {
          img: '**',
          allincome: '园区币',
          money: '3420'
        },
      ],
      tableData: [
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
        {
          date: "01598753",
          name: "支出",
          address: "0.01",
          from: "退款-刘丽雪",
          time: "2021-4-20",
        },
      ],
      pagesize: 8, //每页的数据条数
      currentPage: 1, //默认开始页面
      istag: true,
    };
  },
  methods: {


     current_change:function(currentPage){
        this.currentPage = currentPage;
      }
    },
      created:function(){
         this.total=this.tableData.length;
      },
      };
</script>

<style scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
.marleft40 {
  margin-left: 40px;
}
.martop5 {
  margin-top: 5px;
}
.p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}
.transaction-main {
  width: 99.8%;
  min-width: 1100px;
  height: 954px;
  background: #ffffff;
}
/* 订单编号输入框 */
.order-number-input {
  margin-left: 9px;
  width: 15%;
  height: 32px;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
}
/* 类型选择框 */
.mold {
  margin-left: 3%;
}
.mold-select {
  margin-left: 9px;
  width: 15%;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
}
/*支付方式*/
.pay-type {
  margin-left: 49px;
}
.pay-type-select {
  width: 15%;
  height: 32px;
  margin-left: 9px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
}
.select-text {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  text-indent: 20px;
}
/* 按钮 */
.resetting {
  width: 96px;
  height: 34px;
  background: #cdcdcd;
  border-radius: 6px;
  margin-right: 3%;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.search {
  margin-right: 20px;
  width: 96px;
  height: 34px;
  background: #5189f7;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.clear {
  clear: both;
}
/* 时间范围 */
.time-scope {
  margin-top: 25px;
}
.time-input {
  width: 12%;
  height: 32px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  margin-top: 20px;
  margin-left: 9px;
}
.crossing {
  width: 26px;
  height: 2px;
  background-color: #333333;
  margin-left: 10px;
  margin-top: 33px;
}
.main-body {
  margin-left: 40px;
}
.main-body-one {
  width: 97%;
  height: 166px;
  background: #f7faff;
  border: 1px solid #d7d7d7;
  border-radius: 8px;
  margin-top: 60px;
}
/* 蓝框内部左侧 */
.body-one-left {
  display: flex;
  width: 49%;
  height: 100%;
  justify-content: space-around;
}
.opa1 {
  width: 28%;
  height: 100%;
  float: left;
}
.opa-img {
  width: 24px;
  height: 24px;
  margin-top: 50px;
  margin-left: 23%;
}
.opa-type {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  margin-top: 50px;
}
.opa-count {
  font-size: 28px;
  margin-left: 23%;
  font-family: PingFang SC;
  font-weight: bold;
  color: #5189f7;
}
.body-one-line {
  width: 1px;
  height: 80px;
  background: #f0f5ff;
  border: 1px solid #d7d7d7;
  border-radius: 1px;
  margin-left: 1%;
  margin-top: 43px;
}
/* 蓝框内部右侧 */
.body-one-right {
  width: 49%;
  height: 100%;
}
/*表格*/
.body-table {
  text-align: center;
  margin-top: 30px;
  border: 1px solid #eeeeee;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #323232;
}
.refund {
  color: #5189f7;
}
/*底部分页*/
.main-bottom {
  margin-top: 21px;
  margin-left: 38%;
}
</style>
